import React from 'react';
import useReveal from '../hooks/useReveal';
import './Roadmap.css';

const PHASES = [
  { n: 1, title: 'Interactive Mushroom Cultivation Simulator', status: 'Live focus' },
  { n: 2, title: 'Institution Dashboard', status: 'In development' },
  { n: 3, title: 'AI Farming Assistant', status: 'Planned' },
  { n: 4, title: 'Multi-Crop Simulation Platform', status: 'Planned' },
  { n: 5, title: 'AR/VR Farming Experience', status: 'Planned' },
  { n: 6, title: 'Smart Device & Sensor Integration', status: 'Planned' },
];

export default function Roadmap() {
  const ref = useReveal();
  const listRef = useReveal();
  return (
    <section className="section roadmap" id="roadmap">
      <div className="container">
        <div className="reveal" ref={ref}>
          <p className="eyebrow">Roadmap</p>
          <h2 className="section-heading">From one crop to a full immersive farming platform.</h2>
        </div>

        <div className="roadmap__timeline reveal-stagger" ref={listRef}>
          {PHASES.map((p) => (
            <div className="roadmap__phase" key={p.n}>
              <div className="roadmap__marker">
                <span>{p.n}</span>
              </div>
              <div className="roadmap__body">
                <span className="roadmap__status">{p.status}</span>
                <h3>{p.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
